import Vue from 'vue'
import Router from 'vue-router'
import Routes from './routes'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: Routes.getRoutes()
})
